export default {
      id: "clock-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#clock",
      toString: function () {
        return this.url;
      }
    }